import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const requestSystemStatus = (droneId) => {
    return handler.get(`settings/${droneId}/system-status`);
};
const resetInterface = (droneId, iface) => {
    return handler.post(`settings/${droneId}/reset-interface/${iface}`);
};
const enableRoute = (droneId, routeId) => {
    return handler.post(`settings/${droneId}/enable-route/${routeId}`);
};
const disableRoute = (droneId, routeId) => {
    return handler.post(`settings/${droneId}/disable-route/${routeId}`);
};
const pingGPS = (droneId) => {
    return handler.post(`settings/${droneId}/ping-gps`);
};
const pingCameras = (droneId) => {
    return handler.post(`settings/${droneId}/ping-cameras`);
};
const restartService = (droneId) => {
    return handler.post(`settings/${droneId}/restart-service`);
};
export default {
    requestSystemStatus,
    resetInterface,
    enableRoute,
    disableRoute,
    pingGPS,
    pingCameras,
    restartService,
};
